import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import Maintenance from '../../functions/logic/Maintenance'
import Spiner from '../../components/Spiner'

const BusinessKeysForm = () => {
    const param = useParams();
    const [file, setFile] = useState(null)
    const [password, setPassword] = useState('')
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [spiner, setSpiner] = useState(false)

    const handleFileChange = (e) => {
        setFile(e.target.files[0])
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSpiner(true)
        if (!file) {
            enqueueSnackbar('Por favor, selecciona un archivo.', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
            return;
        }

        if (!password) {
            enqueueSnackbar('Por favor, ingresa la contraseña.', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
            return;
        }

        const response = await Maintenance.saveKeysSignLogic(userToken, param.moduleId, file, password);
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setFile('')
        setPassword('')
        setSpiner(false)
    };


    return (
        <div className="">
            <Spiner opt={spiner} />
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label>Archivo (.p12):</label>
                                    <input type="file" accept=".p12" className="form-control" onChange={handleFileChange} />
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label>Clave del certificado:</label>
                                    <input type="password" value={password} className="form-control" onChange={handlePasswordChange} />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="card-footer">
                                <div className="float-right">
                                    <button type="submit" className="btn btn"><i className="far fa-save"></i> Guardar</button>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </form>
        </div >
    )
}

export default BusinessKeysForm
